import * as ng from 'angular';
import * as _ from 'underscore';

import * as ace from 'ace-builds';
ace.config.setModuleUrl('ace/mode/javascript', require('file-loader?esModule=false!ace-builds/src-noconflict/mode-javascript.js'));
ace.config.setModuleUrl('ace/mode/css', require('file-loader?esModule=false!ace-builds/src-noconflict/mode-css.js'));
ace.config.setModuleUrl('ace/mode/css_worker', require('file-loader?esModule=false!ace-builds/src-noconflict/worker-css.js'));
ace.config.setModuleUrl('ace/mode/javascript_worker', require('file-loader?esModule=false!ace-builds/src-noconflict/worker-javascript.js'));
ace.config.setModuleUrl('ace/theme/monokai', require('file-loader?esModule=false!ace-builds/src-noconflict/theme-monokai.js'));

import { UtilsService, LoaderService } from '../../../shared';

interface CodeFile {
   name:string;
   type:string;
   url?:string;
}

export class CodeEditorController {
   fileMap:{ [fname: string]: string };
   files:CodeFile[];
   onFileUpdate:Function;

   private selectedIndex = -1;

   editor:ace.Ace.Editor;

   static $inject = ['$q', '$http', 'utils', 'dialogs', 'loader'];
   constructor(
      private $q:ng.IQService,
      private $http:ng.IHttpService,
      private utils:UtilsService,
      private dialogs,
      private loader:LoaderService
   ) { }

   $onInit() {
      if (this.fileMap) {
         this.files = _.map(this.fileMap, (v, k) => {
            let i = k.lastIndexOf('_');
            return {
               name: k.substring(0, i),
               type: k.substring(i+1),
               url: v
            };
         });
      } else {
         this.files = [];
      }
   }

   $postLink() {
      this.editor = ace.edit('file-editor', {
         tabSize: 3,
         useSoftTabs: true,
         showInvisibles: true,
         theme: 'ace/theme/monokai'
      });

      this.editor.on('change', (e) => {
         if (this.selected) {
            this.onUpdate(this.selected, this.editor.getValue());
         }
      });
   }

   private onUpdate(file:CodeFile, code:string) {
      let mime = file.type == 'js' ? 'text/javascript' : 'text/css';
      file.url = `data:${mime};base64,${btoa(code)}`;
      this.onFileUpdate({
         name: file.name + '_' + file.type,
         data: file.url
      });
   }

   add(type:'js'|'css') {
      let f = {
         name: this.utils.generateUniqueId(),
         type: type
      };

      this.files.push(f);
      this.selected = f;
   }

   remove(f:CodeFile) {
      let message = `Are you sure you want to delete ${f.name}?`;
      this.dialogs.confirm(message).then(() => {
         this.selectedIndex = -1;
         this.files.splice(this.files.indexOf(f), 1);
         this.onFileUpdate({
            name: f.name + '_' + f.type,
            data: null
         });
      });
   }

   get selected() {
      if (this.selectedIndex >= 0) {
         return this.files[this.selectedIndex];
      }

      return null;
   }

   set selected(f) {
      this.selectedIndex = _.indexOf(this.files, f);

      if (f.type == 'js') {
         this.editor.session.setMode('ace/mode/javascript');
      } else {
         this.editor.session.setMode('ace/mode/css');
      }

      if (f.url) {
         let promise:ng.IPromise<string>;
         if (f.url.indexOf('data:') == 0) {
            let code = this.selected.url.split(';base64,').pop();
            code = atob(code);
            promise = this.$q.resolve(code);
         } else {
            this.loader.showSpinner();
            promise = this.$http.get(f.url).then(res => {
               return res.data as string;
            });
         }

         promise.then(code => {
            this.editor.setValue(code);
            this.editor.clearSelection();
         }).finally(() => this.loader.hide());
      } else {
         this.editor.setValue('');
      }
   }
}

ng.module('e360').component('codeEditor', {
   controller: CodeEditorController,
   templateUrl: require('./code-editor.html'),
   bindings: {
      fileMap: '<files',
      onFileUpdate: '&'
   }
})
